<template>
    <v-row align="center" justify="center"
           class="registration-view">
        <v-col sm="8" md="4" xl="3">
            <v-card class="elevation-12">
                <v-toolbar dark color="primary">
                    <v-toolbar-title>
                        DayToDay - Регистрация
                    </v-toolbar-title>
                </v-toolbar>

                <v-card-text class="pb-0">
                    <v-form ref="registrationForm"
                            @keyup.enter="registerClient"
                            @submit.prevent>
                        <div v-if="errorMessage"
                             v-text="errorMessage"
                             class="mt-3 mb-5 text-error font-weight-bold" />
                        <div v-if="successMessage">
                            <div v-text="successMessage"
                                 class="mt-3 mb-5 text-success font-weight-bold" />
                            <div class="mt-2 mb-5">
                                <router-link :to="{ name: 'loginPage' }">Перейти на страницу входа.</router-link>
                            </div>
                        </div>

                        <v-text-field autofocus
                                      clearable
                                      v-model.trim="email"
                                      :rules="emailRules"
                                      name="email"
                                      label="Email"
                                      placeholder="Email"
                                      autocomplete="email"
                                      type="text"
                                      prepend-icon="mdi-email-outline" />

                        <v-text-field clearable
                                      v-model.trim="login"
                                      :rules="loginRules"
                                      name="login"
                                      label="Логин"
                                      placeholder="Логин"
                                      autocomplete="username"
                                      type="text"
                                      prepend-icon="mdi-account" />

                        <v-text-field clearable
                                      v-model="password"
                                      label="Пароль"
                                      placeholder="Пароль"
                                      autocomplete="new-password"
                                      :type="showPassword ? 'text' : 'password'"
                                      @click:prepend="showPassword = !showPassword"
                                      :prepend-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                                      :rules="passwordRules" />

                        <v-text-field clearable
                                      v-model="passwordConfirmation"
                                      label="Подтверждение пароля"
                                      placeholder="Подтверждение пароля"
                                      autocomplete="new-password"
                                      :type="showPasswordConfirmation ? 'text' : 'password'"
                                      @click:prepend="showPasswordConfirmation = !showPasswordConfirmation"
                                      :prepend-icon="showPasswordConfirmation ? 'mdi-eye' : 'mdi-eye-off'"
                                      :rules="passwordConfirmationRules" />
                    </v-form>
                </v-card-text>

                <v-card-actions class="pt-1 pb-0 mb-2 mr-2">
                    <v-spacer />
                    <v-btn type="button"
                           :to="{ name: 'loginPage' }"
                           variant="elevated"
                           color="secondary">Отмена</v-btn>
                    <v-btn variant="elevated"
                           :disabled="!isValid || isDisabled"
                           @click="registerClient"
                           color="primary">
                        Зарегистрировать
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-col>
    </v-row>
</template>

<script>
    import DataValidator from "@/common/dataValidator";

    export default {
        data() {
            return {
                email: null,
                login: null,
                password: null,
                passwordConfirmation: null,

                showPassword: false,
                showPasswordConfirmation: false,

                isDisabled: false,

                isValidForm: false,
                errorMessage: "",
                successMessage: "",

                loginRules: DataValidator.getLoginRules(),
                emailRules: DataValidator.getEmailRules()
            };
        },

        created() {
            this.$store.dispatch("loadPasswordOptions");
        },

        computed: {
            passwordRules() {
                return DataValidator.getPasswordRules(this.passwordOptions);
            },
            passwordConfirmationRules() {
                return DataValidator.getPasswordConfirmationRules(this.password, this.passwordOptions);
            },

            passwordOptions() {
                return this.$store.state.passwordOptions;
            },

            isComplete() {
                return this.email && this.login && this.password && this.passwordConfirmation;
            },
            isValid() {
                if (this.isComplete) {
                    this.validateForm();
                }

                return this.isComplete && this.isValidForm;
            }
        },

        methods: {
            async validateForm() {
                if (!this.$refs.registrationForm) {
                    return;
                }

                const { valid } = await this.$refs.registrationForm.validate();

                this.isValidForm = valid;
            },

            registerClient() {
                if (!this.isValid || this.isDisabled) {
                    return;
                }

                this.errorMessage = "";
                this.successMessage = "";
                this.isDisabled = true;

                const request = {
                    email: this.email,
                    login: this.login,
                    password: this.password
                };

                this.$store.dispatch("registerClient", request).then(response => {
                    if (!response.data.isSuccess && !response.data.message) {
                        this.$store.commit("error", "Ошибка связи");
                        this.isDisabled = false;
                        return;
                    }

                    if (!response.data.isSuccess) {
                        this.errorMessage = response.data.message;
                        this.isDisabled = false;
                        return;
                    }

                    this.successMessage = response.data.message;
                });
            }
        }
    };
</script>
